import React from 'react'
import useTheme from 'hooks/useTheme'
import { useTranslation } from 'contexts/Localization'
import { ArrowDropDownIcon, Text, DirectBonusIcon, useMatchBreakpoints } from '@nominex/dex-uikit'
import { formatNumber } from 'utils/formatters'
import LoadableValue from 'components/LoadableValue'
import { StyledDropdownTrigger } from './styles'

interface DropdownTriggerProps {
  nmxReward: number
  isLoaded: boolean
  slot?: string
}

const DropdownTrigger: React.FC<DropdownTriggerProps> = ({ nmxReward, isLoaded, ...props }) => {
  const { theme } = useTheme()
  const { t } = useTranslation()
  const { isMobile } = useMatchBreakpoints()

  return (
    <StyledDropdownTrigger {...props}>
      <DirectBonusIcon color="pink500" width="18px" />
      <div className="flex flex-col ml-8 mr-4 whitespace-nowrap items-start">
        <Text fontSize="9px" color={`${theme.colors.text}80`}>
          {t('Unclaimed rewards')}
        </Text>
        <LoadableValue loading={isLoaded} bold fontSize="13px" lineHeight="1.2">
          {formatNumber(nmxReward || 0)} NMX
        </LoadableValue>
      </div>
      <ArrowDropDownIcon
        className="ml-8 w-[10px] arrow-icon"
        color={`${theme.colors.darkGray100}99`}
        style={{ transform: isMobile ? 'rotate(-90deg)' : 'rotate(0)' }}
      />
    </StyledDropdownTrigger>
  )
}

export default DropdownTrigger
